import CoachingNote from './CoachingNote';
import { EmptyHMD } from './HMD';
import { EmptyHMDGoal, HMDGoal } from './HMDGoal';
import { EmptyRAP } from './RAP';
import { EmptyRCR } from './RCR';
import { SummaryMetric } from './SummaryMetric';

export class Metric extends SummaryMetric {
  coachingNotes: CoachingNote[];

  hmdGoal: HMDGoal;

  constructor({ coachingNotes, HMD_GOAL }: any) {
    super({});
    this.coachingNotes = coachingNotes;
    this.hmdGoal = HMD_GOAL;
  }
}

export interface MetricsCSAData {
  countContactReviewRead: number;
  countContactReviewNotRead: number;

  coachedPercentage: number;
  activeCsasTwiceCoachedPercentage?: number;
  contactReviewsDeliveredPercentage: number;

  csaListCoachingDelivered: CSAItem[];
  csaListCoachingNotDelivered: CSAItem[];
  csaListContactReviewDelivered: CSAItem[];
  csaListContactReviewNotDelivered: CSAItem[];
  csaListContactReviewNotOpened: CSAItem[];

  activeAssociates: CSAItem[];
  inactiveAssociates: CSAItem[];
}

export interface CSAItem {
  userId: string;
  fullName: string;
  coachingCount?: number;
}

export interface Stats {
  contactReviews: StatsContactReview[];
  coachingNotes: StatsCoachingNote[];
}

export interface StatsContactReview {
  contactID: string;
  agentUserName: string;
  agentUserID: string;
  deliveredByUserName: string;
  deliveredAt: string;
  contactStatus: string;
}

export interface StatsCoachingNote {
  id: string;
  coachingId: string;
  recipient: StatsCoachingUser;
  createdAt: string;
  deliveredAt: string;
  reviewedAt: string;
  isDelivered: string;
}

export interface StatsCoachingUser {
  userID: string;
  userName: string;
}

export interface ActiveCsas {
  activeCsas: string[]; // List of cscentral_{region}_user:{id} ids
}

export const EmptyMetric: Metric = {
  rcr: EmptyRCR,
  rap: EmptyRAP,
  coachingNotes: [],
  hmdGoal: EmptyHMDGoal,
  hmd: EmptyHMD,
};

export const CSAItemInitialValues = {
  userId: '',
  fullName: '',
};

export const EmptyActiveCsas: ActiveCsas = {
  activeCsas: [],
};

export const MetricsCSADataInitialValues: MetricsCSAData = {
  countContactReviewRead: 0,
  countContactReviewNotRead: 0,

  coachedPercentage: 0,
  activeCsasTwiceCoachedPercentage: 0,
  contactReviewsDeliveredPercentage: 0,

  csaListCoachingDelivered: [],
  csaListCoachingNotDelivered: [],

  csaListContactReviewDelivered: [],
  csaListContactReviewNotDelivered: [],
  csaListContactReviewNotOpened: [],

  activeAssociates: [],
  inactiveAssociates: [],
};
